import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext, useMemo, useCallback } from 'react'
import buildLuxLoyaltySelectedUpgradeKey from 'luxLoyalty/lib/benefits/buildLuxLoyaltySelectedUpgradeKey'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'

function useLuxLoyaltyOfferPageTargetRoomUpgrade(
  originPackage: App.Package,
): {
  selectedTargetUpgradePackage: App.Package | undefined,
  toggleTargetRoomUpgrade: (upgradeSelection: boolean) => void,
} {
  const { luxLoyaltyTargetRoomUpgradesSelected, offer } = useContext(OfferPageStateContext)

  const targetUpgradePackage = useMemo<App.Package | undefined>(() => {
    if (
      !offer ||
      !originPackage.luxLoyalty.targetUpgradePackageUniqueKey
    ) return undefined
    return offer.packages.find(p => {
      return p.uniqueKey === originPackage.luxLoyalty.targetUpgradePackageUniqueKey
    })
  }, [offer, originPackage.luxLoyalty.targetUpgradePackageUniqueKey])

  const selectedUpgradeKey = useMemo(() => {
    return buildLuxLoyaltySelectedUpgradeKey(originPackage, targetUpgradePackage)
  }, [originPackage, targetUpgradePackage])

  const offerPageDispatch = useOfferPageDispatch()

  const hasSelectedTargetRoomUpgrade = selectedUpgradeKey ? !!luxLoyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] : false

  const toggleTargetRoomUpgrade = useCallback((upgradeSelection: boolean) => {
    if (!selectedUpgradeKey) return
    offerPageDispatch({
      type: OfferPageActions.toggleLuxLoyaltyTargetRoomUpgrade,
      selectedUpgradeKey,
      hasSelectedTargetRoomUpgrade: upgradeSelection,
    })
  }, [offerPageDispatch, selectedUpgradeKey])

  return {
    selectedTargetUpgradePackage: hasSelectedTargetRoomUpgrade ? targetUpgradePackage : undefined,
    toggleTargetRoomUpgrade,
  }
}

export default useLuxLoyaltyOfferPageTargetRoomUpgrade
